import Lottie from "lottie-react";
import { Link } from "react-router-dom";
import NotFoundData from "./views/assets/lottie/404-2.json";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 gap-4">
      <Lottie animationData={NotFoundData} loop={true} className="h-[300px]" />
      <div className="max-w-[550px] text-center">
        <p className="text-2xl text-theme ">
          This content isn't available at the moment!
        </p>
        <span className="">
          It looks like the page you’re trying to access doesn’t exist. Please
          check the URL and try again.
        </span>
      </div>
      <Link
        to="/"
        className="px-6 py-3 bg-primary-900 text-white rounded-lg hover:bg-gradient-to-r hover:from-[#1E3A8A] hover:to-[#3B82F6] transition"
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
